import _ from "lodash";

import { BYPASS_PRIVATE_DNS, BypassPrivateDns } from "@sportal/api";
import { DEFAULT_FREQUENCY, DEFAULT_TIME_ZONE } from "./attributes.constants";
import { GET_ACCOUNT_SUCCESS } from "../account/account.types";
import { SERVICES } from "../../common/utils/permissions";
import {
  LOAD_ATTRIBUTES,
  LOAD_ATTRIBUTES_SUCCESS,
  LOAD_ATTRIBUTES_FAILURE,
  CHANGE_LANGUAGE_SUCCESS,
  CHANGE_TIMEZONE_SUCCESS,
  CHANGE_TIME_FORMAT_SUCCESS,
  CHANGE_APR_SETTING_SUCCESS,
  UPDATE_EMAIL_ADDRESS_SUCCESS,
  UPDATE_EMAIL_FREQUENCY_SUCCESS,
  CHANGE_ATTRIBUTE,
  LOAD_TIMEZONES_SUCCESS,
  DISCARD_SCHEDULED_REPORTS_SETTINGS,
} from "./attributes.types";
import { withLoadingState } from "../shared";

interface AccountSettingsState {
  language: string | null;
  is24hourFormat: boolean;
  timezone: string;
  email: ScheduledReports;
  businessName: string | null;
  toSave: {
    email: ScheduledReports;
  };
  timezones: any[];
  aprOn: boolean;
}

interface ScheduledReports {
  address: string;
  frequency: string | null;
}

const initialState: AccountSettingsState = {
  language: null,
  is24hourFormat: false,
  timezone: DEFAULT_TIME_ZONE,
  email: {
    address: "",
    frequency: DEFAULT_FREQUENCY,
  },
  businessName: "",
  toSave: {
    email: {
      address: "",
      frequency: DEFAULT_FREQUENCY,
    },
  },
  timezones: [],
  aprOn: false,
};

const reducer = (state = initialState, action): AccountSettingsState => {
  switch (action.type) {
    case LOAD_ATTRIBUTES_SUCCESS:
      const { address, frequency, language, is24hourFormat, businessName } =
        action.payload;

      return {
        ...state,
        language,
        is24hourFormat,
        email: { address, frequency },
        toSave: {
          email: { address, frequency },
        },
        businessName,
      };
    case GET_ACCOUNT_SUCCESS: {
      const { timezone } = action.payload;

      const sbService = action.payload[SERVICES.SB];
      const bypassPrivateDNS = sbService && sbService[BYPASS_PRIVATE_DNS];

      return {
        ...state,
        ...(!_.isEmpty(timezone) && { timezone }),
        ...(!_.isUndefined(bypassPrivateDNS) && {
          aprOn: bypassPrivateDNS[BypassPrivateDns.ApplePrivateRelay],
        }),
      };
    }
    case LOAD_TIMEZONES_SUCCESS:
      return { ...state, timezones: action.payload };
    case CHANGE_TIMEZONE_SUCCESS:
      return { ...state, timezone: action.payload };
    case CHANGE_TIME_FORMAT_SUCCESS:
      return { ...state, is24hourFormat: action.payload };
    case CHANGE_LANGUAGE_SUCCESS:
      return { ...state, language: action.payload };
    case CHANGE_APR_SETTING_SUCCESS:
      return { ...state, aprOn: action.payload };
    // TODO: use as a generic action for all attributes
    //  requires state shape changes
    case CHANGE_ATTRIBUTE: {
      return {
        ...state,
        toSave: {
          email: {
            ...state.toSave.email,
            ...action.payload,
          },
        },
      };
    }
    case UPDATE_EMAIL_ADDRESS_SUCCESS: {
      return {
        ...state,
        email: {
          ...state.email,
          address: action.payload,
        },
      };
    }
    case UPDATE_EMAIL_FREQUENCY_SUCCESS: {
      return {
        ...state,
        email: {
          ...state.email,
          frequency: action.payload,
        },
      };
    }
    case DISCARD_SCHEDULED_REPORTS_SETTINGS: {
      return {
        ...state,
        toSave: {
          email: {
            ...state.email,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default withLoadingState({
  loadActionType: LOAD_ATTRIBUTES,
  successActionType: LOAD_ATTRIBUTES_SUCCESS,
  failureActionType: LOAD_ATTRIBUTES_FAILURE,
})(reducer);
